







































import Vue from "vue";
import {Component, Emit, Prop, PropSync} from "vue-property-decorator";
import CreateTournamentFormNextButton
  from "@/components/Tournaments/CreateTournament/CreateTournamentFormNextButton.vue";
import {GameType} from "@/core/games/types";
import {ValidationProvider} from "vee-validate/dist/vee-validate.full";
import {CreateTournamentModuleGetterTypes} from "@/store/modules/tournaments/createTournament/types";
import {Getter} from "vuex-class";
import {VuexState} from "@/core/vuex/types";
import {StoreNamespace} from "@/store/types";
import {CreateTournamentStoreModule} from "@/store";
import {ICreateTournamentRequest} from "@/services/account/tournament.types";
import {ValidationObserver} from "vee-validate";
import {has} from 'lodash'

export interface ICreateTournamentFormFirstStepForm {
  name: string
  game_id: number
}

@Component({
  components: {
    ValidationProvider,
    CreateTournamentFormNextButton
  },
  enums: {
    VuexState
  }
})
export default class CreateTournamentFormFirstStep extends Vue {
  @PropSync('currentActiveStepNumber',{ type: Number, required: true }) private currentActiveStepNumberSync!: number
  @Prop({ type: Boolean, required: true }) private invalid!: boolean
  @Prop({ type: Object, required: true }) private parentForm!: ICreateTournamentRequest
  @Prop({ required: true }) private formObserver!: InstanceType<typeof ValidationObserver>

  @Getter(CreateTournamentModuleGetterTypes.CURRENT_VUEX_STATE, { namespace: StoreNamespace.CreateTournament })
  private readonly currentState!: VuexState

  private currentStepNumber: number = 1
  private isEditable: boolean = true

  private gameTypes: Form.ISelectDynamicValueOption<GameType>[] = [
    { value: GameType.LeagueOfLegends, text: 'League Of Legends', disabled: false },
    { value: GameType.None, text: 'None', disabled: false }
  ]

  private form: ICreateTournamentFormFirstStepForm = {
    name: this.parentForm.name,
    game_id: this.parentForm.game_id,
  }

  get isStepCompleted () {
    return this.currentActiveStepNumberSync > this.currentStepNumber
  }

  get isError () {
    if (this.formObserver) {
      return (has(this.formObserver.errors, 'name') && this.formObserver.errors['name'].length > 0) ||
          (has(this.formObserver.errors, 'game_id') && this.formObserver.errors['game_id'].length > 0);
    }
    return false
  }

  @Emit()
  private onDataChange () {
    return this.form
  }

  private onGameIdChange(game_id: number) {
    CreateTournamentStoreModule.setTournamentForm(game_id)
    this.onDataChange()
  }
}
